module.exports = (pageAnalytics, settings) => {
    if (!settings.analytics || !settings.analytics.enableAdobeAnalytics) return;
    pageAnalytics.setupPageChangeWatchers();
    pageAnalytics.push();
};



// WEBPACK FOOTER //
// ./src/configuration/analytics/page-analytics-setup.js